module.exports = __webpack_public_path__ + "img/jcb.87087e5e.png";